<template>
  <base-content>
    <template v-if="loaded">
      <template slot="top">
        <hero-header :heading="account.name" />
      </template>

      <base-header>
        Statement
      </base-header>
      <account-statement :account="account" />

      <template slot="bottom">
        <base-section light>
          <base-header>
            Your Co-funding Investments
          </base-header>
          <user-investments />
        </base-section>
        <base-section>
          <base-header>
            Transaction History
          </base-header>
          <user-transactions />
        </base-section>
      </template>
    </template>
    <template v-else>
      <base-loader />
    </template>
  </base-content>
</template>

<script>
import { mapState } from 'vuex'

import AccountStatement from '@/components/AccountStatement.vue'
import HeroHeader from '@/components/HeroHeader.vue'
import UserInvestments from '@/components/UserInvestments.vue'
import UserTransactions from '@/components/UserTransactions.vue'

export default {
  components: {
    AccountStatement,
    HeroHeader,
    UserInvestments,
    UserTransactions
  },

  metaInfo: {
    title: 'Account'
  },

  data: () => ({
    loaded: false
  }),

  async created () {
    await this.$store.dispatch('core/accounts/get', this.$auth.user.accounts[0]._id)

    this.loaded = true
    this.$options.metaInfo.title = this.account.name

    this.$meta().refresh()
  },

  computed: {
    ...mapState({
      account: store => store.core.accounts.entity
    })
  }
}
</script>
